<template>
<div>
    <pt-page-title :title="(isEdit?'编辑':'新建')+'二维码'"></pt-page-title>
    <pt-qr-code-with-data ref="form" @submitLoading="submitLoading"></pt-qr-code-with-data>
    <div class="button-div">
        <el-button type="primary" @click="submitData" :loading="newLoading">新建</el-button>
        <el-button type="primary" plain :class="$style['submit-button']" @click="cancel">取消</el-button>
    </div>
</div>
</template>
<script>
import ptQrCodeWithData from './withData.vue'
export default {
  components: {
    ptQrCodeWithData
  },
  props: {
    isEdit: {
      type: [Boolean, String],
      default: false
    },
    id: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      newLoading: false
    }
  },
  methods: {
    submitLoading (val) {
      this.newLoading = val
    },
    submitData () {
      this.$refs.form.submit()
    },
    cancel () {
      history.go(-1)
    }
  }
}
</script>
<style module lang="less">
.submit-button{

}
</style>
